/**
 *
 * Asynchronously loads the component for LanguageSwitcher
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LanguageSwitcher = lazyLoad(
  () => import('./index'),
  module => module.LanguageSwitcher,
);
